import FooterActions from './FooterActions';
import DebtStatus from './DebtStatus';

interface SummaryFooterProps {
  onFinish: () => void;
  onGoToStart: () => void;
  isProcessing?: boolean;
  compliances: Record<string, number>;
}

const SummaryFooter = ({
  onFinish,
  onGoToStart,
  isProcessing = false,
  compliances,
}: SummaryFooterProps) => {
  const hasDebt = compliances.nonReported > 0;

  return (
    <div className='w-full sticky bottom-0 z-10 bg-white rounded-2xl border border-gray-200 py-6 px-8 shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.1)] transition-all mt-8'>
      <div className='flex flex-col md:flex-row items-center justify-between gap-8'>
        <DebtStatus 
          hasDebt={hasDebt} 
          nonReportedCount={compliances.nonReported} 
        />
        
        <FooterActions 
          onFinish={onFinish} 
          onGoToStart={onGoToStart}
          isProcessing={isProcessing}
        />
      </div>
    </div>
  );
};

export default SummaryFooter;
